import { Outlet } from '@tanstack/react-router';
import cx from 'classnames';

import { useAgentContext } from '../../shared/app/contexts/AgentContext';

/**
 * Agent layout page - same structure as integrations (Integrations.tsx).
 * Owns the pageContainer + contentWrapper and SideNav pin/unpin layout.
 * Child routes (Manage, Policies) render inside the content wrapper via Outlet.
 */
export function Agent() {
  const { agentState } = useAgentContext();
  const isMenuPinned = agentState.isMenuPinned;
  return (
    <div
      className={cx(
        'Agent-pageContainer',
        isMenuPinned && 'Agent-pageContainer--isMenuPinned'
      )}>
      <Outlet />
    </div>
  );
}
